module.exports = __webpack_public_path__ + "static/media/dumbell.1fdd62c0.svg";